const d = (o) => o.reduce((c, e) => {
  if (typeof e == "object") {
    const r = !!Object.values(e)[0], u = Object.keys(e)[0];
    return r ? `${c} ${u}` : c;
  } else
    return `${c} ${e}`;
}, "").trim();
export {
  d as classes
};
